import React from 'react'

import { makeStyles } from '@material-ui/core/styles'

import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'

const useStyles = makeStyles(theme => ({
  
}))

const SimpleTableActions = ({
  item,
  actions,
  children,
}) => {
  const classes = useStyles()

  return (
    <div>
      {
        actions
          .filter(action => {
            if(action.shouldDisplay) return action.shouldDisplay(item)
            return true
          })
          .map((action, i) => {
            const IconClass = action.getIcon ? action.getIcon(item) : action.icon
            const title = action.getTitle ? action.getTitle(item) : action.title

            const button = (
              <IconButton onClick={ (event) => {
                event.stopPropagation()
                if(action.handler) {
                  action.handler(item, event)
                }
              }}>
                <IconClass />
              </IconButton>
            )

            const renderButton = action.wrapButton ? action.wrapButton(button, item) : button
            return (
              <Tooltip disableFocusListener key={ i } title={ title }>
                { renderButton }
              </Tooltip>
            )
          })
      }
      { children }
    </div>
  )
}

export default SimpleTableActions